<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmh"><a id="page_xii"></a><span class="bold">Dramatis Personae</span></h2>
<p class="noindent"><span class="bold">MI5</span></p>
<p class="noindent"><span class="bold">Brig. H.I. ‘Harry’ Allen</span>, Director, C &amp; D Divisions</p>
<p class="noindent"><span class="bold">Hugh Astor</span> B1a</p>
<p class="noindent"><span class="bold">Milicent Bagot</span> B4b</p>
<p class="noindent"><span class="bold">Susan Barton</span> B1a</p>
<p class="noindent"><span class="bold">John Bingham</span> B5b</p>
<p class="noindent"><span class="bold">Roland Bird</span> B3a</p>
<p class="noindent"><span class="bold">F/Lt Charles Cholmondeley</span> B1a; member of the Twenty Committee</p>
<p class="noindent"><span class="bold">Maj. Edward Cussen</span> SLB2</p>
<p class="noindent"><span class="bold">Alan Grogan</span> B3d</p>
<p class="noindent"><span class="bold">Brig. Oswald Allen ‘Jasper’ Harker</span> A/Director (1940-41); Deputy Director General (1941-46)</p>
<p class="noindent"><span class="bold">Christopher Harmer</span> B1a</p>
<p class="noindent"><span class="bold">Tomás Harris</span> B1g</p>
<p class="noindent"><span class="bold">C.P. (Cyril) Harvey</span> B1a</p>
<p class="noindent"><span class="bold">Maj. Gen. Sir Vernon Kell</span> Director General (1909-40)</p>
<p class="noindent"><span class="bold">Maj. Maxwell Knight</span> B5b</p>
<p class="noindent"><span class="bold">Maj. Gilbert Lennox</span> Room 055, War Office, MI5 liaison</p>
<p class="noindent"><span class="bold">Capt. Guy Liddell</span> ADB1, B Division</p>
<p class="noindent"><span class="bold">W.E. ‘Billy’ Luke</span> B1a</p>
<p class="noindent"><span class="bold">John Marriott</span> B1a; secretary of the Twenty Committee</p>
<p class="noindent"><span class="bold">Maj. J.C. (John) Masterman</span> B1a; chairman of the Twenty Committee</p>
<p class="noindent"><span class="bold">Cyril Mills</span> B1a</p>
<p class="noindent"><span class="bold">Desmond Orr</span> Room 055, War Office, MI5 liaison</p>
<p class="noindent"><span class="bold">Brig. Sir David Petrie</span>, Director General (1941-46)</p>
<p class="noindent"><span class="bold">Lt Col Thomas Argyll ‘Tar’ Robertson</span> B1a</p>
<p class="noindent"><span class="bold">Victor, Lord Rothschild</span> B1c</p>
<p class="noindent"><span class="bold">Dick Goldsmith White</span> ADB, Assistant Director, B Division</p>
<p class="noindent"><span class="bold">D.H. Whyte</span> B2a</p>
<p class="noindent"><span class="bold">D. Ian Wilson</span> B1a</p>
<p class="noindent"><span class="bold">Kenneth Younger</span> ADE, Assistant Director, E Division</p>
<p class="noindent"><span class="bold">William ‘Bill’ Younger</span> B5b, cousin to Kenneth Younger</p>
<p class="noindent1"><span class="bold">MI6/SIS</span></p>
<p class="noindent"><span class="bold">Felix Cowgill</span> Head, Section V</p>
<p class="noindent"><a id="page_xiii"></a><span class="bold">Maj. Frank Foley</span> Section V</p>
<p class="noindent"><span class="bold">Capt. M. Lloyd</span> Section Vx</p>
<p class="noindent"><span class="bold">Sir Stewart Menzies</span> ‘C’, Chief of SIS (1939-52)</p>
<p class="noindent"><span class="bold">Ian ‘Tim’ Milne</span> Section Vd</p>
<p class="noindent"><span class="bold">H.A.R. ‘Kim’ Philby</span> Section Vd</p>
<p class="noindent"><span class="bold">Col Valentine Vivian</span> VCSS, Vice Chief of SIS</p>
<p class="noindent1"><span class="bold">Double Cross Agents</span></p>
<p class="noindent"><span class="bold">ARTIST</span> Johann ‘Johnny’ Jebsen,</p>
<p class="noindent"><span class="bold">BALLOON</span> Christopher ‘Dicky’ Metcalfe (German: IVAN II)</p>
<p class="noindent"><span class="bold">CARELESS</span> Clarc Korab</p>
<p class="noindent"><span class="bold">DREADNOUGHT</span> Ivo Popov</p>
<p class="noindent"><span class="bold">G.W.</span> Gwilym Williams</p>
<p class="noindent"><span class="bold">GELATINE</span> Friedl Gartner (German: YVONNE)</p>
<p class="noindent"><span class="bold">METEOR</span> Eugn Šoštarić</p>
<p class="noindent"><span class="bold">TATE</span> Wulf Schmidt</p>
<p class="noindent"><span class="bold">TRICYCLE</span>; <span class="bold">SKOOT</span> Dušan ‘Duško’ Miloradoff Popov (German: IVAN I)</p>
<p class="noindent"><span class="bold">VELOCIPEDE</span> Unidentified</p>
<p class="noindent"><span class="bold">THE WORM</span> Stefan Zeis</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Dramatis.vue?74222c34